<div class="sub-heading mt-0" tabindex="0">
  {{addBookmarkLabel}}
</div>
<div class="mx-2-5 mb-3-5">
  <div class="my-1 right-panel-label-color" tabindex="0">
    {{bookmarkingLabel}}
  </div>
  <app-location-breadcrumb></app-location-breadcrumb>
</div>

<div class="mx-2-5 mb-3-5">
  <mat-form-field class="width-100 mb-1">
    <mat-label class="textBox-text">{{addBookmarktitle}}</mat-label>
    <div class="textarea-wrapper flex-display">
      <textarea appAutoFocus class="textBox-text textarea-padding" type="text" matInput cdkTextareaAutosize
                cdkAutosizeMinRows="1"
                cdkAutosizeMaxRows="6" (input)="BookMarkTitleModified($event.target.value)" [formControl]="bookmarkTitle" maxlength="100"></textarea>
    </div>
  </mat-form-field>

  <div class="flex-display pt-1-5rem">
    <button mat-button class="btn-secondary-action-close" (click)="closeOverlay()" (keyup.enter)="closeOverlay()" tabindex="0">{{cancelButtonLabel}}</button> &nbsp;
    <button mat-button class="btn-primary-action-add" (click)="Submit()" (keyup.enter)="Submit()" tabindex="0">{{bookmarksubmit}}</button>
  </div>
</div>























